import "./utils/SentryUtils";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "react-tooltip/dist/react-tooltip.css";

// Allow BigInt to be serialized to JSON
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(BigInt.prototype as any).toJSON = function () {
  return this.toString();
};

createRoot(document.getElementById("root")!).render(<App></App>);
